import { render, staticRenderFns } from "./NoResultInfo.vue?vue&type=template&id=5cfa3341"
import script from "./noResultInfo.ts?vue&type=script&lang=ts&external"
export * from "./noResultInfo.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cfa3341')) {
      api.createRecord('5cfa3341', component.options)
    } else {
      api.reload('5cfa3341', component.options)
    }
    module.hot.accept("./NoResultInfo.vue?vue&type=template&id=5cfa3341", function () {
      api.rerender('5cfa3341', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/explore/no-result-info/NoResultInfo.vue"
export default component.exports